import React from "react";
import { TableProps } from "..";
import theme from "@/constants/theme";

interface TableRowProps {
  columns: TableProps["columns"];
  row: TableProps["data"][0];
  components: TableProps["components"];
  index: number;
}

const TableRow: React.FC<TableRowProps> = (props) => {
  const { columns, row, components } = props;

  const ActionComponent = components?.Action;

  return (
    <tr style={styles.tr}>
      {columns.map((cell, index) => {
        const cellContent =
          cell.render && row !== null && row !== undefined
            ? cell.render(row)
            : row?.[cell.field];

        return (
          <td key={`${cell?.field}-${row?.id ?? index}`} style={styles.td}>
            {cellContent ?? ""}
          </td>
        );
      })}
      {ActionComponent && (
        <td style={styles.td}>
          <ActionComponent data={row} />
        </td>
      )}
    </tr>
  );
};

const styles: Record<string, React.CSSProperties> = {
  td: {
    padding: "10px",
  },
  tr: {
    backgroundColor: "inherit",
    borderBottom: "1px solid",
    borderTop: "1px solid",
    borderColor: theme.colors.border,
  },
  even: {
    backgroundColor: theme.colors.background.secondary,
  },
};

export default TableRow;
